


























































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import OpportunityCompanyGeneralDetailsEdit from '@/components/Opportunities/OpportunityCompanyGeneralDetailsEdit.vue';
import OpportunityCompanyAddressEdit from '@/components/Opportunities/OpportunityCompanyAddressEdit.vue';

@Component({
  name: 'OpportunityClientTab',
  components: { OpportunityCompanyGeneralDetailsEdit, OpportunityCompanyAddressEdit },
})
export default class extends GiganautVue {
  get opportunity() { return OpportunityDetailsModule.opportunity; }

  get statusLabel(): string {
    if (!this.opportunity) return '';
    if (this.opportunity.companyId) return 'Existing';
    if (this.opportunity.prospectCompanyName) return 'New';
    return '';
  }

  get hasAnyDetails(): boolean {
    if (!this.opportunity) return false;
    return !!this.opportunity.company || !!this.opportunity.prospectCompanyName;
  }

  companyField(linkedKey: string, prospectKey: string): string {
    if (!this.opportunity) return '';
    if (this.opportunity.company) return (this.opportunity.company as any)[linkedKey] || '';
    return (this.opportunity as any)[prospectKey] || '';
  }

  get companyGeometry(): { lat: number; lng: number } | null {
    if (!this.opportunity) return null;
    if (this.opportunity.prospectCompanyAddressLatitude != null && this.opportunity.prospectCompanyAddressLongitude != null) {
      return { lat: this.opportunity.prospectCompanyAddressLatitude, lng: this.opportunity.prospectCompanyAddressLongitude };
    }
    return null;
  }

  get companyAddressDisplay(): string {
    if (!this.opportunity) return '';
    const parts = [
      this.opportunity.prospectCompanyAddressBuilding,
      this.opportunity.prospectCompanyAddressStreet,
      this.opportunity.prospectCompanyAddressLocality,
      this.opportunity.prospectCompanyAddressCity,
      this.opportunity.prospectCompanyAddressRegion,
      this.opportunity.prospectCompanyAddressPostcode,
      this.opportunity.prospectCompanyAddressCountry,
    ].filter(p => !!p);
    return parts.join(', ');
  }
}
